import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import { Route, Routes } from "react-router-dom";
import Admin from "./admin";
import User from "./user";
import hasRole from "./utils/functions/hasRole";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./redux/hooks";
import { getCars, getCatalogs, getEngines, setCart } from "./redux/reducers";
import { getLoginModal, getRegistrationModal } from "./redux/selectors";
import RegistrationModal from "./components/RegistrationModal";
import { LoginModal } from "./components";

const App = () => {
  const isAdmin = true;
  const dispatch = useAppDispatch();
  const regState = useAppSelector((state) => getRegistrationModal(state));
  const loginState = useAppSelector((state) => getLoginModal(state));
  const getLocalData = () => {
    let stored = localStorage.getItem("cart");
    return stored ? JSON.parse(stored) : "";
  };
  useEffect(() => {
    dispatch(getCatalogs());
    dispatch(getCars());
    dispatch(getEngines());
    dispatch(setCart(getLocalData()));
  }, []);

  return (
    <>
      <Routes>
        <Route path="/*" element={<User />} />
        {isAdmin && <></>}
        <Route path="/admin/*" element={<Admin />} />
      </Routes>
      {regState ? <RegistrationModal /> : loginState ? <LoginModal /> : <></>}
    </>
  );
};

export default App;
